<template>
  <div id="duihuan">
    <div>
        <van-notice-bar
          wrapable
          :scrollable="false"
          :text="'反诈积分必须转换成商城积分才能在商城兑换奖品。您现有活动积分：' + userInfo.integral"
        />
        <div class="options">
          <div @click="exchange">
            <van-icon name="exchange" size="50" />
            <div>
              我要转换
            </div>
          </div>
          <div>
            <a href="https://zswlf.wlxww.com/zswl/miandeng?redirect=%2F%2F88425.activity-42.m.duiba.com.cn%2Fchw%2Fvisual-editor%2Fskins%3Fid%3D296808">
              <van-icon name="shop-o" size="50" />
              <div>
                前往商城
              </div>
            </a>
          </div>
        </div>

        <div class="exchange-record">
          <div class="title">积分转换记录</div>
          <div class="lists" v-if="integralHistory.length > 0">
            <div class="list van-hairline--bottom" v-for="(v, k) in integralHistory" :key="k">
              <div>{{v.integral}}积分</div>
              <div><van-icon name="clock-o"></van-icon>{{v.createtime}}</div>
            </div>
          </div>
          <div v-else>
            <van-empty description="暂无" />
          </div>
        </div>
    </div>

    <van-popup v-model="showPopup" position="bottom" closeable @click-close-icon="showPopup = false" :style="{ height: '30%' }" >
      <div class="exchange-popup">
        <div v-if="success">
          <van-icon name="checked" color="#04be02" size="80"></van-icon>
          <div>转换成功</div>
        </div>
        <div v-else>
          <div>当前可转换的积分为：{{userInfo.integral}}</div>
          <div>
            <van-form @submit="onExchange">
              <van-field name="stepper" label="转换积分">
                <template #input>
                  <van-stepper v-model="stepper" :max="userInfo.integral" />
                </template>
              </van-field>

              <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit" :disabled="stepper <= 0 || stepper > userInfo.integral || submitting">转换</van-button>
              </div>
            </van-form>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';

import { getFanzhaUserInfo, getIntegralHistory, exchangeIntegral } from '@/api/fanzha';

export default {
  name: 'Duihuan',
  data(){
    return {
      themeId: 3,
      userInfo: {integral: 0},
      integralHistory: [],
      showPopup: false,
      stepper: 1,
      success: false,
      submitting: false
    }
  },
  mounted(){
    getFanzhaUserInfo({themeId: this.themeId}).then((res) => {      
      if(res.code == 1){
        if(res.data == null){
          this.$route.push({
            path: `/fanzha/list`
          })
        }else{
          this.userInfo = res.data;
        }
      }else{
        Toast.fail(res.msg);
      }
    });

    getIntegralHistory({themeId: this.themeId, target: 'exchange'}).then((res) => {
      if(res.code == 1){
        this.integralHistory = res.data;
      }else{
        Toast.fail(res.msg);
      }
    });

  },
  methods: {
    exchange(){
      this.showPopup = true;
    },
    onExchange(){
      if(this.submitting) return false;
      this.submitting = true;

      exchangeIntegral({themeId: this.themeId, stepper: this.stepper}).then((res) => {
        if(res.code == 1){
          this.success = true;
          this.userInfo.integral = this.userInfo.integral - this.stepper;
          let mydate = new Date();
          mydate.toLocaleDateString();
          this.integralHistory.unshift({integral: '-' + this.stepper, createtime: mydate.toLocaleString().replace(/\//g, '-')})
          setTimeout(() => {
            this.showPopup = false;
          }, 1500);
        }else{
          Toast.fail(res.msg)
        }
        this.submitting = false;
      })
    }
  }
}
</script>

<style lang="less" scoped>
.options {
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  margin-top: 20px;
  a {
    color: #fff;
  }
}

.exchange-record {
  margin-top: 20px;
  background-color: #fff;
  border-radius: 20px;
  color: #000;
  padding: 10px;
  .title {
    text-align: center;
    font-size: 18px;
  }
  .lists {
    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
    }
  }
}

.exchange-popup {
  padding-top: 20px;
  margin: 20px;
  color: #000;
  text-align: center;
  form {
    margin-top: 20px;
  }
}
</style>